import React, {Component, createRef} from 'react'
import PropTypes from 'prop-types'
import {renderAsync} from 'docx-preview/dist/docx-preview.js'
import {documentsService} from '../../service/docments_service'
import {downloadUtils} from '../../utils/downloadUtils'
import {$$} from '../../helpers/localization'

function getMimeCategory(mimeType) {
    if (!mimeType) return 'unsupported';
    if (mimeType === 'application/pdf') return 'pdf';
    if (mimeType.startsWith('image/')) return 'image';
    if (mimeType === 'text/html') return 'html';
    if (mimeType === 'text/plain' || mimeType === 'text/csv'
        || mimeType === 'application/json' || mimeType === 'application/xml'
        || mimeType === 'text/xml') return 'text';
    if (mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') return 'docx';
    return 'unsupported';
}

export default class DocumentViewer extends Component {
    _isMounted = true;
    docxContainerRef = createRef();

    state = {
        loading: true,
        error: false,
        blobUrl: null,
        textContent: null,
        docxReady: false
    }

    componentDidMount() {
        this.loadDocument();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.docxReady && !prevState.docxReady && this.docxContainerRef.current) {
            renderAsync(this.docxBlob, this.docxContainerRef.current, null, {
                className: 'document-viewer__docx-wrapper'
            });
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.cleanup();
    }

    cleanup = () => {
        if (this.state.blobUrl) {
            URL.revokeObjectURL(this.state.blobUrl);
        }
    }

    loadDocument = () => {
        this.cleanup();
        this.setState({loading: true, error: false, blobUrl: null, textContent: null});

        documentsService.downloadFileRaw(this.props.entry.id).then(blob => {
            if (!this._isMounted) return;

            const category = getMimeCategory(this.props.entry.mime_type);
            if (category === 'text') {
                blob.text().then(text => {
                    if (this._isMounted) {
                        this.setState({textContent: text, loading: false});
                    }
                });
            } else if (category === 'docx') {
                this.docxBlob = blob;
                this.setState({docxReady: true, loading: false});
            } else {
                this.setState({blobUrl: URL.createObjectURL(blob), loading: false});
            }
        }).catch(() => {
            if (this._isMounted) {
                this.setState({error: true, loading: false});
            }
        });
    }

    handleDownload = () => {
        documentsService.downloadFile(this.props.entry.id).then(url => {
            downloadUtils.download(url, this.props.entry.filename);
        });
    }

    renderContent() {
        const category = getMimeCategory(this.props.entry.mime_type);

        switch (category) {
            case 'pdf':
                return <iframe src={this.state.blobUrl} className="document-viewer__iframe" title={this.props.entry.title}/>;
            case 'image':
                return <img src={this.state.blobUrl} className="document-viewer__image" alt={this.props.entry.filename}/>;
            case 'html':
                return <iframe src={this.state.blobUrl} sandbox="allow-same-origin" className="document-viewer__iframe" title={this.props.entry.title}/>;
            case 'text':
                return <pre className="document-viewer__text">{this.state.textContent}</pre>;
            case 'docx':
                return <div ref={this.docxContainerRef} className="document-viewer__docx"/>;
            default:
                return (
                    <div className="document-viewer__unsupported">
                        <i className="flaticon2-file" style={{fontSize: '3rem', color: '#d1d5db'}}/>
                        <p>{$$("preview_not_available")}</p>
                        <button className="btn btn-primary btn-sm" onClick={this.handleDownload}>
                            {$$("download_btn")}
                        </button>
                    </div>
                );
        }
    }

    render() {
        if (this.state.loading) {
            return (
                <div className="document-viewer">
                    <div className="document-viewer__loading">
                        <div className="med-search-loader" style={{width: '50px', height: '50px', borderWidth: '5px'}}/>
                    </div>
                </div>
            );
        }

        if (this.state.error) {
            return (
                <div className="document-viewer">
                    <div className="document-viewer__error">
                        <p>{$$("preview_error")}</p>
                        <button className="btn btn-secondary btn-sm" onClick={this.loadDocument}>
                            {$$("retry_btn")}
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div className="document-viewer">
                {this.renderContent()}
            </div>
        );
    }
}

DocumentViewer.propTypes = {
    entry: PropTypes.object.isRequired
}
